import billingsTranslationsHelper from "../../../../../languages/billings-translations.helper";
import BillingDetailsTableColumn from "./types/billing-details-table-column";

const getTableColumns = (): BillingDetailsTableColumn[] => {
  const translations =
    billingsTranslationsHelper.getTaxiDriverEditBillingsTranslations()
      .billingSummary.table;

  const tableColumns: BillingDetailsTableColumn[] = [
    {
      header: translations.headers.dateLabel,
      title: translations.headers.dateTitle,
      accessor: "date",
      colSpan: 6,
    },
    {
      header: translations.headers.internalOrderIdLabel,
      title: translations.headers.internalOrderIdTitle,
      accessor: "internalOrderId",
      colSpan: 5,
    },
    {
      header: translations.headers.driverLabel,
      title: translations.headers.driverTitle,
      accessor: "driver",
      colSpan: 5,
    },
    {
      header: translations.headers.passengerLabel,
      title: translations.headers.passengerTitle,
      accessor: "passengers",
      colSpan: 5,
    },
    {
      header: translations.headers.modelLabel,
      title: translations.headers.modelTitle,
      accessor: "model",
      colSpan: 5,
    },
    {
      header: translations.headers.rateLabel,
      title: translations.headers.rateTitle,
      accessor: "rate",
      colSpan: 5,
    },
    {
      header: translations.headers.calculatedRateForDistanceLabel,
      title: translations.headers.calculatedRateForDistanceTitle,
      accessor: "calculatedRateForDistance",
      colSpan: 5,
    },
    {
      header: translations.headers.distanceLabel,
      title: translations.headers.distanceTitle,
      accessor: "distance",
      colSpan: 4,
    },
    {
      header: translations.headers.additionalDistanceLabel,
      title: translations.headers.additionalDistanceTitle,
      accessor: "additionalDistance",
      colSpan: 4,
    },
    {
      header: translations.headers.sumOfDistanceLabel,
      title: translations.headers.sumOfDistanceTitle,
      accessor: "sumOfDistance",
      colSpan: 4,
    },
    {
      header: translations.headers.amountForDistanceLabel,
      title: translations.headers.amountForDistanceTitle,
      accessor: "amountForDistance",
      colSpan: 5,
    },
    {
      header: translations.headers.amountForChargeHaltingsLabel,
      title: translations.headers.amountForChargeHaltingsTitle,
      accessor: "amountForChargeHaltings",
      colSpan: 6,
    },
    {
      header: translations.headers.amountForChargeHighwaysLabel,
      title: translations.headers.amountForChargeHighwaysTitle,
      accessor: "amountForChargeHighways",
      colSpan: 6,
    },
    {
      header: translations.headers.sumOfBonusesLabel,
      title: translations.headers.sumOfBonusesTitle,
      accessor: "sumOfBonuses",
      colSpan: 6,
    },
    {
      header: translations.headers.sumOfPenaltiesLabel,
      title: translations.headers.sumOfPenaltiesTitle,
      accessor: "sumOfPenalties",
      colSpan: 6,
    },
    {
      header: translations.headers.allContributionsAmountLabel,
      title: translations.headers.allContributionsAmountTitle,
      accessor: "allContributionsAmount",
      colSpan: 6,
    },
  ];

  return tableColumns;
};

const billingDetailsHelper = {
  getTableColumns,
};

export default billingDetailsHelper;
